import { IkasBlogCategory } from ".";
import { createIkasBaseModel } from "../../base/init";

/**
 * Initializes the given blog category.
 * @param blogCategory Blog category to initialize.
 */
export function initIkasBlogCategory(blogCategory: IkasBlogCategory) {
  blogCategory.image = blogCategory.imageId
    ? { id: blogCategory.imageId, isVideo: false }
    : undefined;
}

/**
 * Creates an empty blog category object.
 * @returns An initialized empty blog category object.
 */
export function createIkasBlogCategory(): IkasBlogCategory {
  const blogCategory: IkasBlogCategory = {
    ...createIkasBaseModel(),
    imageId: "",
    name: "",
    metadata: {
      ...createIkasBaseModel(),
      id: "",
      slug: "",
    },
  };

  initIkasBlogCategory(blogCategory);

  return blogCategory;
}
